__turbopack_context__.v({
  "changeEmailCancelButton": "ChangeEmailPopup-module__XRqI3q__changeEmailCancelButton",
  "changeEmailContainer": "ChangeEmailPopup-module__XRqI3q__changeEmailContainer",
  "contentContainer": "ChangeEmailPopup-module__XRqI3q__contentContainer",
  "emailField": "ChangeEmailPopup-module__XRqI3q__emailField",
  "imageContainer": "ChangeEmailPopup-module__XRqI3q__imageContainer",
});
